// src/api/favorites.js
import client from './client.js';

export const favoritesAPI = {
  getAll: () => client.get('/favorites'),
  check: (productId) => client.get(`/favorites/check/${productId}`),
  add: (productId) => client.post(`/favorites/${productId}`),
  remove: (productId) => client.delete(`/favorites/${productId}`),
};